import classNames from 'classnames';
import React, { useEffect, useMemo, useRef } from 'react';
import { DocumentNeueCoreEditor } from 'src/document-editor/neue-core-editor';
import { Nullable } from 'src/types/nullable.type';
import { ImageBlock } from '../components/image-block';
import { MutualActionPlanBlock } from '../mutual-action-plans/components/block';
import { PlayerLayoutManager, PlayerLayoutOutputs } from '../layout-manager/player-layout-manager';
import { Block, BlockRenderElement, LayoutMode, Section, Size } from '../types';
import { LinkBlock } from '../links/block';

type Props = {
  width: number;
  height: number;
  renderElements: BlockRenderElement[];
  layoutMode: Nullable<LayoutMode>;
  onBlockSize: (blockId: Block['id'], size: Size) => void;
};

export const NeuePlayerDesktopContent = ({ width, height, renderElements, layoutMode, onBlockSize }: Props) => {
  return (
    <div
      className='relative'
      style={{
        width: `${width}px`,
        height: `${height}px`,
      }}
    >
      {renderElements.map((renderElement) => {
        const { block, rect } = renderElement;
        return (
          <div
            key={renderElement.block.id}
            className='absolute'
            style={{
              top: `${rect.y}px`,
              left: `${rect.x}px`,
              width: `${rect.width}px`,
              height: `${rect.height}px`,
            }}
          >
            {block.content.type === 'text' ? (
              <div className={classNames('w-full h-full transition rounded-2xl bg-white')}>
                <DocumentNeueCoreEditor
                  editable={false}
                  selected={false}
                  hasFocus={false}
                  selectionCoords={null}
                  rect={rect}
                  content={block.content.value}
                  verticalAlignment={block.layout.verticalAlign}
                  horizontalAlignment={block.content.horizontalAlignment}
                  onTextSize={(width, height) => onBlockSize(block.id, { width, height })}
                  onSetVerticalAlignment={() => {}}
                  onSetHorizontalAlignment={() => {}}
                  onUpdate={() => {}}
                  onFocus={() => {}}
                  onBlur={() => {}}
                  layoutMode={layoutMode}
                />
              </div>
            ) : block.content.type === 'image' ? (
              <ImageBlock block={block} selected={false} onDelete={() => {}} />
            ) : block.content.type === 'mutual-action-plan' ? (
              <MutualActionPlanBlock
                uuid={block.content.uuid}
                block={block}
                selected={false}
                editable={false}
                contextMenuOpen={false}
                useActiveStyle={false}
              />
            ) : block.content.type === 'link' ? (
              <LinkBlock
                block={block}
                selected={false}
                editable={false}
                forceHoverState={false}
                useActiveStyle={false}
                onBlockSizeChange={(width, height) => onBlockSize(block.id, { width, height })} />
            ) : (
              JSON.stringify(block)
            )}
          </div>
        );
      })}
    </div>
  );
};
